import React, { useCallback, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import ProfileDetails from "../../Components/ProfileDetails";
import { RiderModel } from "../../Api/Models/rider.model";
import { useLoading } from "../../Context/LoadingProvider";
import { useInfoModal } from "../../Context/InfoModalProvider";
import { riderService } from "../../Api/Services/RiderService";
import { useTranslation } from "react-i18next";
import Stepper from "../../Components/Stepper";
import { HomeIcon } from "../../Components/Icons/HomeIcon";
import { SearchIcon } from "../../Components/Icons/SearchIcon";

interface RiderProfileLayoutProps {}

export interface RiderProfileLayoutContextInterface {
  setPageTitle: CallableFunction;
  rider: RiderModel;
  setRider: CallableFunction;
  showTabsNavbar: boolean;
  setShowTabsNavbar: CallableFunction;
  setHasGear: CallableFunction;
  setGearExchangeRequired: CallableFunction;
  setSubTitle: CallableFunction;
  subTitle: string;
  setGearMissing: CallableFunction;
  fetchRider: CallableFunction;
  setShowProfileInfo: CallableFunction;
}

const RiderProfileLayout: React.FunctionComponent<
  RiderProfileLayoutProps
> = () => {
  const { t } = useTranslation();

  const [title, setTitle] = useState<string>();
  const [subTitle, setSubTitle] = useState<string>(t("Gear Owned by the Rider") ?? "");
  const [showTabsNavbar, setShowTabsNavbar] = useState<boolean>(true);
  const [showProfileInfo, setShowProfileInfo] = useState<boolean>(true);
  const [hasGear, setHasGear] = useState<boolean>(true);
  const [gearMissing, setGearMissing] = useState<number | null>(null);
  const [gearExchangeRequired, setGearExchangeRequired] =
    useState<boolean>(false);
  const { startLoading, finnishLoading } = useLoading();

  let { riderId } = useParams();
  const { state } = useLocation();
  const [rider, setRider] = useState<RiderModel>(state?.riderModel);
  const { showInfo } = useInfoModal();
  const navigate = useNavigate();

  const [stepperCurrent, setStepperCurrent] = useState<number>(0);
  const [stepperTotal, setStepperTotal] = useState<number>(0);

  const location = useLocation();
  const isProfileActive = location.pathname.includes("/rider/" + riderId + "/profile");

  useEffect(() => {
    if (!rider) {
      if (!riderId) {
        showInfo(t("Invalid QR code"));
        navigate("/menu");
        return;
      }

      fetchRider();
    }
    //eslint-disable-next-line
  }, []);


  const fetchRider = () => {
    if (!riderId) {
      showInfo(t("Invalid QR code"));
      navigate("/menu");
      return;
    }
    startLoading("get-rider");

    riderService
      .get(riderId)
      .then((rider) => {
        setRider(rider);
      })
      .catch((e) => {
        showInfo(t("Invalid QR code"));
        navigate("/menu");
      })
      .finally(() => {
        finnishLoading("get-rider");
      });
  };

  const setPageTitle = useCallback(
    (titleToBeSet: string) => setTitle(titleToBeSet),
    []
  );

  return (
    <div className={"view-container " + (isProfileActive ? "background-white" : "view-container--stretch background")}>
      <div className={"view-content " + (!isProfileActive && "h-full flex flex-col justify-between")}>
          {title}
        {stepperTotal > 0 &&
          <Stepper className="stepper--light mb-6" current={stepperCurrent} total={stepperTotal} closeCallback={() => navigate("/menu")}  />
        }

        {isProfileActive &&
          <div>
              <div className="navigationbar navigationbar--dark mb-6">
                  <div className="navigationbar__left">
                      <Link to="/rider/search" className="navigationbar__button">
                          <SearchIcon width={18} height={18} />
                      </Link>
                  </div>
                  <div className="navigationbar__center">
                      <div className="navigationbar__title text-purple">{t("Rider profile")}</div>
                  </div>
                  <div className="navigationbar__right">
                      <Link to="/menu" className="navigationbar__button">
                          <HomeIcon />
                      </Link>
                  </div>
              </div>
          </div>
        }

         <div className="inner-view-container">
          <div className="inner-view-content background-white">
   
          
          {rider && (
            <>
              {showProfileInfo && (<div className="mb-4">
                <ProfileDetails
                  rider={rider}
                  hasGear={hasGear}
                  gearMissing={gearMissing}
                  gearExchange={gearExchangeRequired}
                />
              </div>)}

              <Outlet
                context={{
                  setPageTitle,
                  rider,
                  setRider,
                  showTabsNavbar,
                  setShowTabsNavbar,
                  setHasGear,
                  setGearExchangeRequired,
                  subTitle,
                  setSubTitle,
                  setGearMissing,
                  fetchRider,
                  setShowProfileInfo,
                  setStepperValues: (current: number, total: number) => {
                    setStepperCurrent(current);
                    setStepperTotal(total);
                  },
                }}
              />
            </>
          )}


          </div>
        </div>
      </div>
    </div>
  );
};

export default RiderProfileLayout;
